var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button-group',{staticClass:"m-3"},[_c('b-button',{attrs:{"variant":"secondary","to":"/admin"}},[_vm._v("文章列表")]),_c('b-button',{attrs:{"variant":"primary","to":"/admin/add"}},[_vm._v("新增文章")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }